const types = {
  SET_UI_SETTINGS: 'SET_UI_SETTINGS',
};

const state = {
  records: {
    rtl_view: false,
  },
};

export const getters = {
  getUISettings($state) {
    return $state.records || {};
  },

  getAuthUIFlags($state) {
    return { isFetching: false };
  }
};

export const actions = {
  updateUISettings: async ({ commit }, params) => {
    try {
      commit(types.SET_UI_SETTINGS, params);
    } catch (error) {
      // Ignore error
    }
  },
};

export const mutations = {
  [types.SET_UI_SETTINGS]($state, { uiSettings }) {
    $state.records = {
      ...$state.records,
      ...uiSettings,
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
